import Link from "next/link";
import clsx from 'clsx'

export default function TOCLink({id, level, minLevel, text, activeSection}) {
    return (
        <Link
            href={`#${id}`}
            id={`link-${id}`}
            className={clsx(
                'hover:text-gray-700 focus:outline-none dark:hover:text-gray-200',
                'focus-visible:text-gray-700 dark:focus-visible:text-gray-200',
                activeSection === id
                    ? 'font-semibold text-green-100'
                    : 'text-brown-100'
            )}
            style={{ marginLeft: (level - minLevel) * 16 }}
        >
            {text}
        </Link>
    );
}
